import { render, staticRenderFns } from "./revenuestatement.vue?vue&type=template&id=00f4a548&"
import script from "./revenuestatement.vue?vue&type=script&lang=js&"
export * from "./revenuestatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports